module.exports = __webpack_public_path__ + "img/star-ai-card@2x.b2198d7f.png";